import Papa from 'papaparse';

export const loadQuestions = async () => {
    return new Promise((resolve, reject) => {
        Papa.parse('/healthcheck/questions.csv', {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                if (results.errors.length > 0) {
                    console.error('CSV Parse Errors:', results.errors);
                    reject(results.errors);
                    return;
                }

                const questions = results.data.map((row) => {
                    // Parse ResponseOptions to determine type and options
                    // "Yes;No" -> Radio with options
                    // "FreeText" or "" -> Text
                    let type = 'Radio';
                    let options = [];

                    const responseOptions = row.ResponseOptions ? row.ResponseOptions.trim() : '';

                    if (!responseOptions || responseOptions.toLowerCase() === 'freetext') {
                        type = 'Text';
                    } else {
                        type = 'Radio';
                        options = responseOptions.split(';').map(o => o.trim());
                    }

                    return {
                        section: row.Section,
                        id: row.QuestionNumber,
                        text: row.QuestionText,
                        type,
                        options,
                        action: row.Action
                    };
                });
                resolve(questions);
            },
            error: (error) => {
                reject(error);
            },
        });
    });
};
